import { FormattedHTMLMessage } from "react-intl";

import Message from "@components/Message";

import { AnnouncingHeader } from "../AnnouncingHeader/AnnouncingHeader";

interface ReviewPendingProps {
  logo: JSX.Element;
}

export const ReviewPendingComponent = ({ logo }: ReviewPendingProps) => {
  return (
    <div className="sid-header sid-l-horz-center" data-testid="sid-review-pending">
      <div className="sid-l-horz-center">{logo}</div>
      <AnnouncingHeader align="center">
        <FormattedHTMLMessage
          id="step.pending.titleReview"
          defaultMessage="Reviewing"
          tagName="h1"
        />
      </AnnouncingHeader>
      <div>
        <FormattedHTMLMessage
          id="step.pending.uploadedDocument"
          defaultMessage="Your document was uploaded successfully and is being reviewed."
        />
      </div>
      <div className="sid-header__subtitle-one sid-l-space-top-md">
        <Message id="step.pending.turnaroundTime" />
      </div>
      <div className="sid-header__subtitle-two sid-l-space-top-md">
        <FormattedHTMLMessage
          id="step.pending.subtitle2"
          defaultMessage="Wait here or let us notify you of the outcome."
        />
      </div>
      <div className="sid-header__subtitle-three sid-l-space-top-md">
        <FormattedHTMLMessage
          id="step.pending.subtitle3"
          defaultMessage="You will be contacted via email."
        />
      </div>
      <div className="sid-l-space-top-xl" />
    </div>
  );
};
